module.exports = __webpack_public_path__ + "media/newstyle/images/icon-a5-5a10fde432cf6aee44e1eb321b24ce42.svg";